var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrdbg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 929,
    height: 338,
    viewBox: "0 0 929 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M683.509 96.4583C687.52 85.7423 682.115 73.7231 671.437 69.6126L657.146 76.0389C667.824 80.1494 673.229 92.1686 669.219 102.885L683.509 96.4583Z",
    fill: "url(#paint0_linear_183_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.533 130.039C921.999 119.534 909.774 114.613 899.227 119.048L893.376 133.584C903.923 129.149 916.149 134.069 920.682 144.575L926.533 130.039Z",
    fill: "url(#paint1_linear_183_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.448 307.886C801.726 318.308 806.31 330.664 816.688 335.483L831.378 330.033C821.001 325.213 816.416 312.858 821.139 302.436L806.448 307.886Z",
    fill: "url(#paint2_linear_183_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2707 283.008C41.3242 294.449 50.6428 303.768 62.0846 303.821L73.1642 292.742C61.7224 292.688 52.4038 283.37 52.3503 271.928L41.2707 283.008Z",
    fill: "url(#paint3_linear_183_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1388 97.5059C32.6696 86.0736 23.0184 77.0998 11.5822 77.4623L0.912665 88.9372C12.3488 88.5747 22 97.5486 22.4692 108.981L33.1388 97.5059Z",
    fill: "url(#paint4_linear_183_189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.419 4.37349C219.979 4.14789 210.436 13.2366 210.104 24.6736L220.91 36.0201C221.242 24.583 230.786 15.4944 242.225 15.72L231.419 4.37349Z",
    fill: "url(#paint5_linear_183_189)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_183_189",
    x1: 682.981,
    y1: 80.5584,
    x2: 664,
    y2: 88.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_183_189",
    x1: 915.135,
    y1: 118.941,
    x2: 907.249,
    y2: 138.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_183_189",
    x1: 805.906,
    y1: 323.786,
    x2: 825.407,
    y2: 316.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_183_189",
    x1: 47.407,
    y1: 297.685,
    x2: 62.1825,
    y2: 283.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_183_189",
    x1: 26.4731,
    y1: 83.0611,
    x2: 12.2366,
    y2: 98.1496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_183_189",
    x1: 216.596,
    y1: 10.1501,
    x2: 230.793,
    y2: 25.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.899867,
    stopColor: "#D0C8FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrdbg);
export default __webpack_public_path__ + "static/media/prdbg.200c69635f325b64d1942bda4c516a43.svg";
export { ForwardRef as ReactComponent };